module.exports = __webpack_public_path__ + "img/award-my-prize.73bfa619.png";